import { TopupAmountItem } from './../../Models/TopupAmountsViewModel';

export default {
    name: "topup-prices",
    template: '#topup-prices',
    data: function () {
        return {
            defaultTopupOption: {} as TopupAmountItem,
            receiverCurrenciesCount: 1
        }
    },
    props: {
        availableTopupOptions: {} as Array<TopupAmountItem>
    },
    beforeMount() {
        this.defaultTopupOption = new TopupAmountItem();
    },
    watch: {
        availableTopupOptions: function (newVal: Array<TopupAmountItem>, _: Array<TopupAmountItem>) {

            if (newVal.length > 0) {
                this.defaultTopupOption = newVal[0];

                if (this.defaultTopupOption.Pricing)
                    this.receiverCurrenciesCount = this.defaultTopupOption.Pricing.length;
            }
        }
    },
}